"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.mapLineVariant = exports.mapSizeToClass = exports.mapArrowVariantToClass = exports.mapVariantToIcon = exports.mapVariantToIconClass = exports.mapVariantToBoxClass = void 0;
var caution_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/caution.icon.svg"));
var exclamation_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/exclamation.icon.svg"));
var information_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/information.icon.svg"));
var success_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/success.icon.svg"));
var Popover_module_scss_1 = __importDefault(require("./Popover.module.scss"));
var mapVariantToBoxClass = function (variant) {
    switch (variant) {
        case "informative":
            return Popover_module_scss_1["default"].informativeBox;
        case "positive":
            return Popover_module_scss_1["default"].positiveBox;
        case "negative":
            return Popover_module_scss_1["default"].negativeBox;
        case "cautionary":
            return Popover_module_scss_1["default"].cautionaryBox;
        default:
            return Popover_module_scss_1["default"].defaultBox;
    }
};
exports.mapVariantToBoxClass = mapVariantToBoxClass;
var mapVariantToIconClass = function (variant) {
    switch (variant) {
        case "informative":
            return Popover_module_scss_1["default"].informativeIcon;
        case "positive":
            return Popover_module_scss_1["default"].positiveIcon;
        case "negative":
            return Popover_module_scss_1["default"].negativeIcon;
        case "cautionary":
            return Popover_module_scss_1["default"].cautionaryIcon;
        default:
            return undefined;
    }
};
exports.mapVariantToIconClass = mapVariantToIconClass;
var mapVariantToIcon = function (variant) {
    switch (variant) {
        case "informative":
            return information_icon_svg_1["default"];
        case "positive":
            return success_icon_svg_1["default"];
        case "negative":
            return exclamation_icon_svg_1["default"];
        case "cautionary":
            return caution_icon_svg_1["default"];
        default:
            return information_icon_svg_1["default"];
    }
};
exports.mapVariantToIcon = mapVariantToIcon;
var mapArrowVariantToClass = function (variant) {
    switch (variant) {
        case "informative":
            return Popover_module_scss_1["default"].informativeArrow;
        case "positive":
            return Popover_module_scss_1["default"].positiveArrow;
        case "negative":
            return Popover_module_scss_1["default"].negativeArrow;
        case "cautionary":
            return Popover_module_scss_1["default"].cautionaryArrow;
        default:
            return Popover_module_scss_1["default"].defaultArrow;
    }
};
exports.mapArrowVariantToClass = mapArrowVariantToClass;
var mapSizeToClass = function (size) {
    switch (size) {
        case "large":
            return Popover_module_scss_1["default"].large;
        default:
            return "";
    }
};
exports.mapSizeToClass = mapSizeToClass;
var mapLineVariant = function (singleLine) {
    return singleLine ? Popover_module_scss_1["default"].singleLine : "";
};
exports.mapLineVariant = mapLineVariant;
//# sourceMappingURL=classMappers.js.map